module.exports = __webpack_public_path__ + "img/test01.31080815.png";